import { makeStyles } from "@mui/styles";
import { COLORS } from "../../constant/colors";

const useStyles = makeStyles((_) => ({
  row: {
    width: "100%",
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyItems: "center",
    '@media (max-width: 500px)': {
      flexDirection: "column",
    }
  },
  col: {
    width: "50%",
    height: "100%",
    "@media (max-width: 500px)": {
      width: "100%",
    },
  },
  leftcol: {
    display: "flex",
    alignItems: "center",
    background: "#fff",
    justifyItems: "center",
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    padding: 30,
    '@media (max-width: 500px)': {
      borderBottomLeftRadius: 0,
    }
  },
  loginImg: {
    maxWidth: 300,
    margin: "0 auto",
    '@media (max-width: 500px)': {
      maxWidth: 200,
    }
  },
  closeButton: {
    position: "absolute",
    top: 10,
    right: 20,
    width: 40,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease-in-out",
    borderRadius: "50%",
    cursor: "pointer",
    "&:hover": {
      background: "#f1f1f1",
      "& i": {
        color: "#000",
      },
    },
    "& i": {
      color: "#fff",
      '@media (max-width: 500px)': {
        color: COLORS.primary,
      },
    },
  },
  heading: {
    fontSize: "30px !important",
    textAlign: "center",
    color: COLORS.white,
    fontFamily: "Poppins",
    position: "relative",
    marginBottom: 30,
    "&:before": {
      content: '""',
      position: "absolute",
      bottom: -10,
      left: "calc(50% - 38px)",
      width: 70,
      borderRadius: 5,
      height: 3,
      background: "#fff",
      zIndex: 100,
    },
    '@media (max-width: 500px)': {
      fontSize: "22px !important",
      marginTop: 20,
    }
  },
  description: {
    color: COLORS.white,
    fontSize: 15,
    fontFamily: "Poppins",
    fontWeight: "400",
    textAlign: "center",
    marginBottom: 30,
    '@media (max-width: 500px)': {
      marginBottom: 20,
    }
  },
  PhoneNumber: {
    fontWeight: "bold",
  },
  formRow: {
    alignItems: "center",
    justifyItems: "center",
    textAlign: "center",
  },
  inputFeild: {
    color: `${COLORS.white} !important`,
    padding: "10px 0 !important",
    "& label": {
      color: `${COLORS.white} !important`,
    },
    "& input": {
      color: `${COLORS.white} !important`,
    },
  },
  submit: {
    border: "none",
    padding: "8px 30px",
    background: COLORS.white,
    color: "#000",
    width: "100%",
    borderRadius: "5px",
    margin: "20px 15px",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      background: COLORS.secondary,
      color: COLORS.white,
    },
  },
  rightcol: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px 40px",
    "@media (max-width: 650px)": {
      padding: "10px 20px !important",
    },
    "@media (max-width: 550px)": {
      padding: "10px 15px !important",
    },
  },
}));

export default useStyles;
